import React, {Component, PropTypes} from 'react'
import VideoPlayer from '../FranklyVideoPlayerAdapter';
import Cannonicalize from '../Cannonicalize';
import Analytics from '../Analytics'

class PlayFirstClipFromCategory extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    //all the import links are set from the config file
    this.affiliate = props.affiliate;
    this.state ={}
  }

  componentWillMount(){
    try {
      this.findVideoSources(Cannonicalize.category(this.props.FRN_rawResponses[0].data))
    } catch (e) {
      e.message += ' in PlayFirstClipFromCategory for category #'+ this.categoryId
    }
    if(typeof window !== 'object')
      return
    ClientSideCacheController.get('category',{id: this.props.categoryId})
    .then(this.findVideoSources)
  }

  findVideoSources = (category) =>{
    try{
      let title = category.features[0].headline
      let srcs = category.features[0].group.map(function(feed){
          feed.src = decodeURIComponent(feed.url)
          return feed
      }).filter(function(feed){
        if(feed.type =="video/mp4" )
          return true
      })

      this.setState({title: title,videoSrcs: srcs});

    }
    catch(e){
      e.message += ' in PlayFirstClipFromCategory findVideoSources for category #'+this.categoryId
      Analytics.reportError(e)
    }
  }

  render() { // REQUIRED
    return (
      <div className='gnm-play-first-clip-from-category' >
        <h5 className='white-at-small' style={{marginBottom: '10px'}}>{this.props.title || this.state.title}</h5>
        {
          this.state.videoSrcs
          ? <VideoPlayer  sources={this.state.videoSrcs}  contentClass={this.props.contentClass}/>
          : null
        }
      </div>
    )
  }
}

export default PlayFirstClipFromCategory



// WEBPACK FOOTER //
// ./app/components/custom/ssr/PlayFirstClipFromCategory/index.js